// extracted by mini-css-extract-plugin
export default {"playButton":"playButton_playButton__0ZKbc","playButtonIcon":"playButton_playButtonIcon__7A2gY"};